/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { FileManagementApiConfiguration as __Configuration } from '../file-management-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultAttachmentUrlInfo } from '../models/list-query-result-attachment-url-info';
@Injectable({
  providedIn: 'root',
})
class UrlService extends __BaseService {
  static readonly GetAllPath = '/api/files/internal/urls';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `UrlService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `ids`:
   *
   * - `expiryDateTime`:
   *
   * @return Success
   */
  GetAllResponse(params: UrlService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultAttachmentUrlInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    (params.ids || []).forEach(val => {if (val != null) __params = __params.append('ids', val.toString())});
    if (params.expiryDateTime != null) __params = __params.set('expiryDateTime', params.expiryDateTime.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/files/internal/urls`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultAttachmentUrlInfo>;
      })
    );
  }
  /**
   * @param params The `UrlService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `ids`:
   *
   * - `expiryDateTime`:
   *
   * @return Success
   */
  GetAll(params: UrlService.GetAllParams): __Observable<ListQueryResultAttachmentUrlInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultAttachmentUrlInfo)
    );
  }
}

module UrlService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
    ids?: Array<string>;
    expiryDateTime?: string;
  }
}

export { UrlService }
